.color_selector {
  display: grid;
  gap: 12px;
  row-gap: 10px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  align-items: start;
  @media (max-width: 499px) {
    grid-template-columns: 1fr 1fr 1fr;
  }
}
.payment_terms {
  font-size: 12px;
  text-align: center;
  margin-top: 15px;
}